import styles from '@/components/Common/SideNavigation/Logo/Logo.styles';

// FUNCTIONS
export const GET_WRAPPER_STYLES = (collapse: boolean) => {
  return styles[collapse ? 'collapsed' : 'wrapper'];
};
